(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sj-conseils-intro"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.sj-ed-nav a[data-sj-target], .sj-ed-pagination a');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const target = document.getElementById(link.dataset.sjTarget);
    const destination = new URL(link.href);
    event.preventDefault();
    event.stopPropagation();
    if (target && destination.pathname === location.pathname && destination.search === location.search) {
      history.replaceState(null, '', link.href);
      target.scrollIntoView({ behavior: 'instant', block: 'start' });
    } else {
      location.assign(link.href);
    }
  }, true);

  } catch(e) { console.error(e); }
})();
})();
